var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isOpening ? _c('div', {
    staticClass: "centered-content"
  }, [_c('p', [_vm._v("檔案開啟中...")])]) : _c('div', {
    staticClass: "centered-content"
  }, [_c('p', [_vm._v("本檔案已於外部瀏覽器開啟")]), _c('button', {
    staticClass: "green-button",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回 LINE 官方帳號")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }